module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/246399942353dd551ac62621fd0fc2c7.png";